import { css } from "@emotion/core";

import { color, fontSizes, fonts } from "../../../theme/Theme";

export const eligibilityCardStyles = css({
  // Eligibility Card Styles.
  ".eligibility-text": {
    color: color.darkGrey,
    fontSize: fontSizes.title
  },
  ".utilized-percent, .residue-percent": {
    fontFamily: fonts.bold,
    color: color.progressDarkBlue
  },
  ".residue-percent": {
    color: color.pink
  },
  ".percent-label": {
    fontSize: fontSizes.label,
    fontFamily: fonts.bold
  },
  ".total-loan-amount": {
    fontFamily: fonts.bold,
    color: color.darkGrey
  },
  ".amount-bullet-point": {
    color: color.darkGrey
  },
  ".utilize-amount-dot": {
    borderRadius: "50%",
    background: color.progressDarkBlue,
    width: "0.5rem",
    height: "0.5rem"
  },
  ".residue-amount-dot": {
    borderRadius: "50%",
    background: color.pink,
    width: "0.5rem",
    height: "0.5rem"
  },
  ".eligibility-card-footer": {
    fontSize: fontSizes.title
  },
  ".eligibility-card-footer__bold": {
    fontSize: fontSizes.cardLabel,
    fontFamily: fonts.bold
  },
  ".ant-progress-text": {
    fontSize: fontSizes.cardLabel
  }
});
